import { createFileRoute } from "@tanstack/react-router";
import Page, { faqItems } from "@/pages/AlimentacaoSaudavelHospitality";
import { pageHead, faqJsonLd, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/alimentacao-saudavel-hospitality-australia")({
  head: () =>
    pageHead({
      title: "Alimentação saudável trabalhando em hospitality na Austrália | Clara Camille",
      description:
        "Guia de alimentação para brasileiros que trabalham em hospitality na Austrália. Dicas de meal prep, o que comer por turno e como manter a saúde com horários irregulares.",
      path: "/alimentacao-saudavel-hospitality-australia",
      jsonLd: [
        faqJsonLd(faqItems),
        breadcrumbJsonLd([
          { name: "Alimentação saudável em hospitality", path: "/alimentacao-saudavel-hospitality-australia" },
        ]),
      ],
    }),
  component: Page,
});
